import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MinhasRedacoesTable from '../common/tables/minhas-redacoes-table';
import RedacaoForm from '../common/forms/redacao-form';
import { handleInstitucional } from '../../api/institucional';

const MinhasRedacoesArea = () => {

  const [institucional, setInstitucional] = useState(null);
  const [linkPdfInformacoes, setLinkPdfInformacoes] = useState(null);
  const [linkPdfModelo, setLinkPdfModelo] = useState(null);
  const [htmlContent, setHtmlContent] = useState("");
  
  useEffect(function() {
    handleInstitucional().then(function(result) {
      setInstitucional(result[1]);
      if (result[1].pdf_informacoes !== '') {
        setLinkPdfInformacoes(result[1].pdf_informacoes);
      }
      if (result[1].pdf_modelo !== '') {
        setLinkPdfModelo(result[1].pdf_modelo);
      }
      setHtmlContent(result[1].descricao);
    });
  }, []);

  return (
    <>
        <section className="signup__area po-rel-z1 pt-100">
          <div className="container">
          <div className="row">
          <div className="col-xxl-12">
              <div className="blog__wrapper">
                <div className="blog__text mb-40">
                <div style={{textAlign: "right"}}>
                {linkPdfInformacoes !== null && <a href={`https://v1.profaprizattera.com.br/uploads/aluno-redacao/${linkPdfInformacoes}`} className="e-btn border mb-22" target="_blank">Informações</a>}
                {linkPdfModelo !== null && <a href={`https://v1.profaprizattera.com.br/uploads/aluno-redacao/${linkPdfModelo}`} className="e-btn border mb-22" target="_blank">Baixe o modelo da redação</a>}
                </div>
                <h2 className="section__title">Envie sua redação</h2>
                
                  {/* form minha redacoes */}
                  
                  <RedacaoForm htmlContent={htmlContent} />

                  {/* end form minha redacoes */}
                </div>
              </div>
              </div>
            </div>
          </div>
      </section>
      <section className="blog__area pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12">
              <div className="blog__wrapper">
                <div className="blog__text mb-40">
                 
                <h2 className="section__title">Minhas Redações</h2>

                  {/* table pagamento */}
                  
                  <MinhasRedacoesTable />

                  {/* table pagamento */}
                </div>
              </div>
            </div>
          </div>
        </div>
        </section>
    </>
  );
};

export default MinhasRedacoesArea;